import { createSelector } from "reselect";
import get from "lodash/get";
import isArray from "lodash/isArray";

const referralCodeDomain = state => get(state.api, "referralCode.data", {});
const referralCodeErrorReasonDomain = state =>
  get(state.api, "referralCode.errorReason", "");
const isLoading = state => get(state.api, "referralCode.loading", false);

// ***************************************************************
// ****************** referral code selectors ********************
// ***************************************************************

export const referralCodeSelector = createSelector(
  referralCodeDomain,
  referralCodeErrorReasonDomain,
  isLoading,
  (referralCode, errorReason, loading) => {
    if (isArray(referralCode)) {
      return referralCode.map(code => {
        return {
          loading,
          benefits: code.benefits,
          title: code.title,
          reason: code.reason || code.message_code || errorReason,
          valid: code.code === 0,
          value: code.referral_code,
          port_in_only: code.port_in_only
        };
      });
    }

    return {
      loading,
      benefits: referralCode.benefits,
      title: referralCode.title,
      reason: referralCode.reason || referralCode.message_code || errorReason,
      valid: referralCode.code === 0,
      value: referralCode.referral_code,
      port_in_only: referralCode.port_in_only
    };
  }
);

export const rowReferralCodeSelector = createSelector(
  referralCodeDomain,
  codes => {
    return codes;
  }
);

// ***************************************************************
// ****************** referral code makeSelect *******************
// ***************************************************************

export const makeSelectReferralCode = () => referralCodeSelector;
export const makeSelectRowReferralCode = () => rowReferralCodeSelector;
